import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
//api
import { getAllCommissions } from 'api/pathForHook/commissions';
import { getFilters } from 'api/commisions';
//utils
import { formatCurrency } from 'utils/currencyFormatter';
//helpers
import { formatDateToSpanish, exportExcel } from 'helpers';
//customHooks
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import Title from 'components/backoffice/texts/title';
import FiltersTable from './FiltersTable';
import CustomTable from 'components/backoffice/customTable';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import Button from 'components/backoffice/buttonCustom';
import StatusBudget from 'components/budget/StatusBudget';

const Commissions = () => {
  const [listCommissions, setListCommissions] = useState([]);
  const [page, setPage] = useState(1);
  const [formFilter, setFormFilter] = useState({
    commission_status: '',
    benefited_company: ''
  });
  const [itemsCommissionStatus, setItemsCommissionStatus] = useState([]);
  const [itemsBenefitedCompany, setItemsBenefitedCompany] = useState([]);
  const [responseInfo, setResponseInfo] = useState({});
  const [btnExportEnabled, setBtnExportEnabled] = useState(true);
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()
  const { fetchData, stateData, loading } = useHandleSearch();
  const userPermissions = usePermissions();

  const colsCommisions = [t('code'), t('benefited_library'), t('date'), t('commision_status'), t('commission_percentage'), t('commission_amount'), t('total_order')];

  const getListCommisions = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        commission_status: formFilter.commission_status,
        benefited_company: formFilter.benefited_company
      }
      await fetchData(getAllCommissions(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const getListFilters = async () => {
      try {
        const { data, status } = await getFilters();
        if (data && status === 200) {
          const newItems = data?.benefited_libraries?.map((val, i) => {
            return { id: val.id, value: val['name'] };
          });

          setItemsBenefitedCompany(newItems);

          const combined = data.status.map(([value, label]) => ({
            id: value, value: label
          }))
          setItemsCommissionStatus(combined);
        }
      } catch (error) {
        console.error(error);
      }
    }
    getListFilters()
  }, [])


  useEffect(() => {
    setTitle(t('commissions'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    getListCommisions();
  }, [page, formFilter]);

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListCommissions(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setListCommissions(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  const handleClear = () => {
    setPage(1);
    setFormFilter({
      commission_status: '',
      benefited_company: ''
    });
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }))
    getListCommisions();
  }

  const handleExportCommissions = async (payload) => {
    setBtnExportEnabled(false);
    exportExcel(
      'payment/commission-summary/export/',
      payload,
      Cookies.get('access'),
      'commissions',
      setBtnExportEnabled
    );
  }

  const serializerStatusOrder = (status) => {
    if (status === 'paid') {
      return 'success';
    } else {
      return 'warning';
    }
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('commissions')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={9} xs={12} className="d-flex text-start">
          <FiltersTable
            formFilter={formFilter}
            handleClear={handleClear}
            setFormFilter={setFormFilter}
            t={t}
            page={page}
            setPage={setPage}
            itemsCommissionStatus={itemsCommissionStatus}
            itemsBenefitedCompany={itemsBenefitedCompany}
          />
        </Col>
        <Col md={3} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('pedido.__commission_export') && (
            <Button
              variant="secondary"
              color="primary"
              onClick={() => handleExportCommissions(formFilter)}
            >
              {t('export')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsCommisions}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listCommissions &&
            listCommissions.map((listCommission, index) => (
              <tr key={index}>
                <td>#{listCommission.code}</td>
                <td>{listCommission.benefited_company}</td>
                <td>{formatDateToSpanish(listCommission.date)}</td>
                <td>
                  <StatusBudget text={listCommission.commission_status} status={serializerStatusOrder(listCommission.commission_status)} />
                </td>
                <td>{`${listCommission.commission_percentage}%`}</td>
                <td>{formatCurrency(listCommission.commission_amount)}</td>
                <td className="text-end">{formatCurrency(listCommission.total_order)}</td>
              </tr>
            ))}
        </CustomTable>
      </div>
    </div>
  );
}

export default Commissions;